<template lang="pug">
  v-container(fluid)
    v-snackbar(v-model="showSnackBar" :timeout="5000" :color="snackBarColor" )
        | {{ snackBarText }}
        v-btn(fab text @click="showSnackBar = false")
            v-icon fal fa-times-circle
    ControlOrderDialog(
      v-if="showControlDialog"
      :show="showControlDialog"
      :currentSelection="currentSelection"
      :topMenuGroup="effectiveMenuGroups[tab]"
      :date="dateLabel"
      :restore="restore"
      :reservationItem="reservationItem"
      :showConfirmButtons="showConfirmButtons"
      :isMultiplePortion="isMultiplePortion"
      :isBoarderNote="isBoarderNote"
      :isMultipleGroupMenu="isMultipleGroupMenu"
      :menuGroupList="effectiveMenuGroups"
      @restoreOffer="restoreOffer"
      @confirm="onConfirmDialogClick"
      @confirmKioskOrder="onConfirmDialogClick"
      @close="onCloseControlDialogClick"
      )
    v-dialog(v-if="isInvalidCredentials && isKioskMode" v-model="isInvalidCredentials" width="1000px" persistent)
      v-card
        v-card-title.text-h5 {{ $t('orderPage.confirmNotAccepted') }}
        v-row.ma-0.mr-12
          v-col.text-end.pt-6.pr-6(cols="1")
            v-icon(large color="error") fas fa-exclamation-circle
          v-col.text-start.pl-0(cols="10" align="start")
            v-card-title.text-h5.title-style.pl-0 {{ $t('orderPage.cardNotAcceptedMessage') }}
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" @click="isInvalidCredentials=false") {{ $t('errorResponseDialog.closeButtonLabel') }}

    v-card.ma-3(flat v-if="!isKioskMode")
      v-card-title.justify-center.headline.text-center.main-title.selected_date(v-if="!isKioskMode") {{ $t('orderPage.headerDateLabel', {date: dateLabel}) }}
      v-row(v-if="timeBlockCollection && timeBlockCollection.length > 1" align="center" justify="center" )
        v-btn-toggle.text-center(v-model="selectedTimeBlock" show-arrows mandatory)
          v-slide-group( show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right" )
            v-slide-item(v-for="(item,idx) in timeBlockCollection" :key="idx" v-model="selectedTimeBlock" )
              v-btn(active-class="primary" :disabled="isTimeBlockDisabled(item) || restartedReservation") {{item.title}}
    v-card(v-if="!isKioskMode")
      v-tabs.style(centered  v-model="tab" show-arrows
      next-icon="fas fa-arrow-right"
        prev-icon="fas fa-arrow-left"
        v-if="showMenuGroupTabs")
        v-tab( v-for="(i, idx) in effectiveMenuGroups" :key="idx") {{i.title}}
      v-tabs-items( v-model="tab")
        v-tab-item( v-for="(a, idx) in effectiveMenuGroups" :key="idx")

          template(v-if="!isOfferEmpty && !setFreeDay")
            v-list.pa-0.transparent.overflow-auto(v-if="effectiveMenuGroups.length && !isKioskMode" )
              GroupOptionSelector(
                v-if="configuration"
                v-for="(subGroupItem, idx) in a.subGroupList" :key="idx" :date="date" :configuration="configuration"  @newAmount="newAmount" :isMultiplePortion="isMultiplePortion"
                :restartReservation="restartReservation" :settingsData="settingsData" :isPriseForTag="isPriseForTag"
                :menuGroupItem="subGroupItem" :subGroupItem="subGroupItem" :reservationItem="getReservationItem(a.id)" :isManipulationAllowed="isManipulationAllowed"
                @selectedOptionChange="onSelectedOptionChange(subGroupItem, $event)"
              )

        v-container.text-center.headline.mt-3.reservation-status(:class="statusMessageClass" v-html="reservationStatusMessage" v-if="!isKioskMode" fluid)
        v-card-text.text-center(v-if="isOfferEmpty && !setFreeDay" style=" font-size: 16px") {{ $t('orderPage.offerIsEmptyMessage') }}

        v-alert.mx-0.mt-5(v-if="!isOfferEmpty && !setFreeDay" dense type="warning" icon="fal fa-exclamation-circle" v-show="isAlertShow") {{ $t('orderPage.dataChangedWarning') }}
        v-alert.mx-0.mt-5(
          v-if="isAcceptanceProcess && getFirstReservationItem && !isOfferEmpty && !isMultipleGroupMenu " dense type="warning"
          icon="fal fa-exclamation-circle" v-show="getFirstReservationItem.acceptanceStatus.name === 'waitlisted'")
          v-row.ma-0.align-center
            v-col.grow.pa-0 {{ $t('orderPage.orderWaitList') }}
            v-col.shrink.pa-0
              v-btn(@click="refreshData" icon :loading="loading" small)
                v-icon fas fa-sync-alt
        v-alert.mx-0.mt-5(
          v-if="isAcceptanceProcess && getMultipleReservationItem && !isOfferEmpty && isMultipleGroupMenu" dense type="warning"
          icon="fal fa-exclamation-circle" v-show="getMultipleReservationItem.acceptanceStatus.name === 'waitlisted'")
          v-row.ma-0.align-center
            v-col.grow.pa-0 {{ $t('orderPage.orderWaitList') }}
            v-col.shrink.pa-0
              v-btn(@click="refreshData" icon :loading="loading" small)
                v-icon fas fa-sync-alt
        v-alert.mx-0.mt-5.pt-5(type="info" border="top" elevation="2" colored-border  v-if="isBoarderNote && reservationItem && reservationItem[0] && reservationItem[0].boarderNote && reservationItem[0].boarderNote !== null " dense icon="fal fa-info-circle" :v-show="reservationItem[0].boarderNote !== null" :style="{'white-space': 'pre-wrap'}" )  {{reservationItem[0].boarderNote}}
        v-alert.mx-0.mt-5(v-if="isAcceptanceProcess && getFirstReservationItem && !isOfferEmpty" dense type="error" icon="fal fa-exclamation-circle" v-show="getFirstReservationItem.acceptanceStatus.name === 'rejected'") {{ $t('orderPage.orderRejected') }}
        v-alert.mx-0.mt-5.text-h5(v-if="isAcceptanceProcess && getFirstReservationItem && !isOfferEmpty" dense type="success" icon="fal fa-exclamation-circle" v-show="getFirstReservationItem.acceptanceStatus.name === 'accepted'") {{ $t('orderPage.orderAccepted') }}
        GroupControlButtons(:selectedOfferRating="selectedOfferRating" :lastReservationNumber="lastReservationNumber" @update="fetchLastData"
          v-if="isManipulationAllowed" :timeBlockCollection="timeBlockCollection" :isSubmitButtonDisabled="isSubmitButtonDisabled" :isAmountChanged="isAmountChanged"
          :date="date" :reservationItem="getFirstReservationItem" :saveInProgress="saveInProgress" :ratingDeliveryTimeData="ratingDeliveryTimeData"
          :cancellationInProgress="cancellationInProgress" :isSelectionChanged="isDataChanged" :lastReservationDetailData="getReservationData"
          @placeNewReservationClick="onPlaceNewReservationClick" @changeReservationClick="onChangeReservationClick"
          @cancelReservationClick="onCancelReservationClick" @restoreReservationClick="onRestoreReservationClick"
        )
      v-card-title.justify-center(v-if="setFreeDay" ) {{ getEventName }}
    v-container.pl-7.pt-0(v-else flat )
      v-card-title.justify-center.headline.text-center.main-title.selected_date.pt-0
      v-row.ma-0()
        v-col.pa-0.pl-3.pb-0.align-content-start.justify-space-between(cols="auto")
          v-card.elevation-0.justify-end(flat)
            v-row(v-if="timeBlockCollection && timeBlockCollection.length > 1" align="start" justify="start")
              v-btn-toggle.text-center( v-model="selectedTimeBlock")
                v-btn(v-for="(item, idx) in timeBlockCollection" :key="idx" :disabled="isTimeBlockDisabled(item) || restartedReservation || getFirstReservationItem && getFirstReservationItem.status === 'canceled'"  mandatory) {{item.title}}
        v-spacer
        v-col.pa-0.text-end.align-content-end.pl-12.justify-end.card-style(cols="auto" align="end" justify="end")
          v-card.ma-0.pa-0.elevation-0.card-style(ref="title")
              v-tabs.style.card-style(centered  v-model="tab" show-arrows
                next-icon="fas fa-arrow-right"
                prev-icon="fas fa-arrow-left")
                v-tab.text-end( v-for="(i, idx) in effectiveMenuGroups" :key="idx") {{i.title}}
        v-col.pa-0.pb-0.pr-2(cols="12")
              v-tabs-items(touchless v-model="tab")
                  v-tab-item( v-for="(a, idx) in effectiveMenuGroups" :key="idx")
                    v-row.ma-0
                      v-col.pb-0.pa-0(cols="12")
                        template(v-if="!isOfferEmpty && !setFreeDay")
                            v-list.pa-0.transparent.pt-0.overflow-y-auto.ma-0.body(v-if="effectiveMenuGroups.length && isKioskMode" :style="cardHeight" )
                                GroupOptionSelector(
                                  v-if="configuration"
                                  v-for="(subGroupItem, idx) in a.subGroupList" :key="idx" :date="date" :configuration="configuration" :index="idx" :isPriseForTag="isPriseForTag"
                                  :restartReservation="restartReservation" :settingsData="settingsData" :subGroupList="a.subGroupList"  @newAmount="newAmount" :isMultiplePortion="isMultiplePortion"
                                  :menuGroupItem="subGroupItem" :subGroupItem="subGroupItem" :reservationItem="getReservationItem(a.id)" :isManipulationAllowed="isManipulationAllowed"
                                  @selectedOptionChange="onSelectedOptionChange(subGroupItem,$event)"
                                )
                        v-row.ma-0.row-style(align="center" justify="center" v-if="isOfferEmpty && !setFreeDay")
                          v-col(cols="12" align="center" justify="center" )
                            v-card.elevation-0
                              v-card-text.text-center.justify-space-around.text-h4( v-if="isOfferEmpty && !setFreeDay" style=" font-size: 16px") {{ $t('orderPage.offerIsEmptyMessage') }}

                  v-divider(v-if="!isOfferEmpty")
                  v-row.ma-0.mt-2(v-if="getFirstReservationItem && getFirstReservationItem.status === 'delivered'" align="center" justify="center" )
                    v-spacer
                    v-col.text-end.pt-3(cols="auto" align="end" justify="end")
                      span.text-h3.text-end.mt-2 {{ $t('orderPage.reservationWasAlreadyDelivered') }}
                  v-card-actions.pt-0
                      GroupControlButtons(:selectedOfferRating="selectedOfferRating" :lastReservationNumber="lastReservationNumber" @update="fetchLastData" :isRefreshData="isRefreshData"
                          v-if="isManipulationAllowed" :timeBlockCollection="timeBlockCollection" :isSubmitButtonDisabled="isSubmitButtonDisabled" :selectedTimeBlock="selectedTimeBlock"
                          :date="date" :reservationItem="getFirstReservationItem" :saveInProgress="saveInProgress" :isOfferEmpty="isOfferEmpty" :isAcceptanceProcess="isAcceptanceProcess"
                          :cancellationInProgress="cancellationInProgress" :isSelectionChanged="isDataChanged" :isTimeBlockChanged="isTimeBlockChanged" :isAmountChanged="isAmountChanged"
                          @placeNewReservationClick="onPlaceNewReservationClick" @changeReservationClick="onChangeReservationClick" :ratingDeliveryTimeData="ratingDeliveryTimeData"
                          @cancelReservationClick="onCancelReservationClick" @restoreReservationClick="onReservationRstoreClick" :lastReservationDetailData="getReservationData"
                      )


                  v-card-title.justify-center(v-if="setFreeDay" ) {{ getEventName }}

    v-dialog(v-model="showCancellationConfirmationDialog" persistent max-width="410" :fullscreen="isKioskMode" scrollable)
        v-card(v-if="!isKioskMode")
            v-card-title {{ $t('orderPage.cancelReservationConfirmTitle') }}
            v-card-text {{ $t('orderPage.saveWarningCancelOrder') }}
            v-card-actions
                v-spacer
                v-btn(text @click="onCancelCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogNoButtonLabel') }}
                v-btn(color="primary" text @click="onConfirmCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogYesButtonLabel') }}
        v-card( v-else-if="isKioskMode && showConfirmButtons")
          v-card-title.text-h3.text-center.justify-space-around {{ $t('orderPage.cancelReservationConfirmTitle') }}
          v-card-text.text-h3.pt-12  {{ $t('orderPage.saveWarningCancelOrder') }}
          v-divider
          v-card-actions
            v-spacer
            v-btn.text-h5(height="50px" text @click="onCancelCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogNoButtonLabel') }}
            v-btn.text-h5(height="50px" color="primary" text @click="onConfirmCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogYesButtonLabel') }}
        v-card.fill-height(v-else)
            v-card-title.text-h3.text-center.justify-space-around {{ $t('orderPage.cancelReservationConfirmDialogTitle') }} : {{dateLabel}}
            v-card-text.text-h3.pt-12 {{ $t('orderPage.saveWarningCancelOrder') }}
              v-row.ma-0.guiding-image(no-gutters)
                v-col.align-center
                  v-img.guiding-image( :src="require('@/assets/hand_with_card.jpg')" contain)
            v-card-title.pr-12.pl-12.title-style.text-h3.text-center {{ $t('orderPage.confirmCanceledKioskOrder') }}
            v-divider
            v-card-actions
                v-spacer
                v-btn.text-h5(color="primary" @click="onCancelCancellationButtonClick" x-large  height="50px" :loading="cancellationInProgress")  {{ $t('orderPage.cancelButtonLabel') }}

</template>

<script lang="ts">
import
  Vue from 'vue'
import {
  DAILY_MENU_TOP_GROUP_CHANGE_SET,
  DAILY_MENU_TOP_GROUP_SAVED, GET_MODE, GET_SELECTED_MENU_ITEM, GET_SHOW_CONTROL_BUTTONS_MODE, USER_LOGGED_IN,
} from '@/store/getter-types'
import GroupOptionSelector from '@/components/order/GroupOptionSelector.vue'
import {
  PLACE_NEW_RESERVATION,
  CHANGE_EXISTING_RESERVATION,
  CANCEL_EXISTING_RESERVATION,
  RESTORE_EXISTING_RESERVATION,
  SET_SELECTED_MENU_ITEM,
  FETCH_RESERVATION_BY_ID,
  ORDER_CONFIRMATION,
  SET_IS_ORDER_CONFIRMATION, FETCH_DASHBOARD
} from '@/store/action-types'
import MenuGroupItem from '@/model/MenuGroupItem'
import DailyMenuOption from '@/model/DailyMenuOption'
import GroupControlButtons from '@/components/order/GroupControlButtons.vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import { TranslateResult } from 'vue-i18n'
import {
  ChangeExistingReservationPayload,
  ChangeExistingReservationWithIdPayload,
  CreateNewReservationPayload,
  ReservationsOffersPayload,
  UserCredentialsPayload
} from '@/types/payload'
import { getLocale } from '@/services/system'
import {
  isValidDateForOrdering,
  isSelectionDifferentThenReservation,
  validateOrderCorrectness
} from '@/services/food-ordering'
import moment from 'moment'
import { ReservationStatus } from '@/types/enums'
import { showErrorResponseDialog } from '@/services/error'
import { AxiosError } from 'axios'
import {Component, Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import Configuration from "@/model/Configuration";
import ControlOrderDialog from "@/components/order/ControlOrderDialog.vue";
import _ from "lodash"
import {RatingModel} from "@/model/RatingModel";
import {usePiniaStore} from "@/store/piniaStore";

@Component({
  components: {
    GroupOptionSelector,
    GroupControlButtons,
    ControlOrderDialog}
})

export default class TopGroup extends Vue {

  @Prop({type: Object as () => MenuGroupItem, required: true}) menuGroupItem!: MenuGroupItem
  @Prop({type: Array as () => MenuGroupItem[], required: true}) menuGroupList!: MenuGroupItem[]
  @Prop({type: Array as () => Configuration[], required: true}) configuration!: Configuration[]
  @Prop({type: Array as () => any[], required: true}) settingsData!: any[]
  @Prop({type: Date, required: true}) date!: Date
  @Prop({type: Array as () => MenuReservationItem[] | null}) reservationItem!: MenuReservationItem[] | null
  @Prop({type: Boolean}) setFreeDay!: boolean
  @Prop({type: Boolean, default: false}) readonly customerConfiguration!: boolean
  @Prop({type: String}) getEventName!: string

  @Action(FETCH_RESERVATION_BY_ID) fetchReservationBySelectedId!: ({ (payload: any): Promise<any[]> })
  @Action(ORDER_CONFIRMATION) orderConfirmation!: ({ (payload: UserCredentialsPayload): Promise<boolean> })
  @Action(SET_IS_ORDER_CONFIRMATION) setIsOrderConfirmation!: ({ (payload: boolean): Promise<void> })


  $refs!: {
    actionHeight: HTMLElement
    title: HTMLElement
  }

  private effectiveMenuGroups: MenuGroupItem[] = []
  private showCancellationConfirmationDialog: boolean = false
  private saveInProgress: boolean = false
  private cancellationInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private currentSelection: Map<MenuGroupItem, any> = new Map()
  private isDataChanged: boolean = false
  private tab: number | null = null
  private restartReservation: boolean = false
  private timeBlockCollection: BusinessTimeBlockCollection[] | null = null
  private timeBlockId: string | null = null
  private business: string | null = null
  private selectedTimeBlock: any | null = null
  private restartedReservation: boolean = false
  private isUpdate: boolean = false
  private showControlDialog: boolean = false
  private selectedMenu: string | undefined = undefined
  private showWaitList: boolean = false
  private loading: boolean = false
  private cardHeight: any | null = null
  private userId: string = ''
  private username: string | null = null
  private partialUserId: string = ''
  private isInvalidCredentials: boolean = false
  private timeOut: ReturnType<typeof setTimeout>  | null = null
  private restore: boolean = false
  private isAmountChanged: boolean = false
  private isMultipleGroupMenu: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] = []
  private ratingDeliveryTimeData: number | undefined = undefined
  private selectedOfferRating: any |null = null
  private piniaStore: any = usePiniaStore()
  private isRefreshData:boolean = false




  get showConfirmButtons (): boolean {
    return this.$store.getters[GET_SHOW_CONTROL_BUTTONS_MODE]
  }

  get getFirstReservationItem (): MenuReservationItem | undefined {
    return _.first(this.reservationItem)
  }

  get getMultipleReservationItem (): MenuReservationItem | undefined {
    let test: any | null = null
    this.reservationItem?.forEach((item: any) => {
      test = item
    })
    return test
  }


  get isTimeBlockChanged (): boolean {
    if(this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && this.timeBlockCollection[this.selectedTimeBlock].id) {
      if( this.timeBlockCollection![this.selectedTimeBlock].id === _.first(this.reservationItem)?.timeBlock.id) {
        return false
      }else if(this.timeBlockCollection![this.selectedTimeBlock].id !== _.first(this.reservationItem)?.timeBlock.id){
        return true
      } else{
        return false
      }
    }
    return false
  }

  get isTimeBlockChangeMultiple (): boolean {
    if(this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && this.timeBlockCollection[this.selectedTimeBlock].id && this.reservationItem && this.reservationItem.length > 0) {
      if(this.reservationItem.find((item: any) => item.timeBlock.id === this.timeBlockCollection![this.selectedTimeBlock].id)) {
        return false
      } else{
        return true
      }
    } else {
      return false
    }
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get dateLabel (): string {
    return moment(this.date)
        .locale(getLocale())
        .format('dddd D.M.Y').toLocaleLowerCase()
  }

  /**
   * Flag či je povolená manipulácia so stavom objednávky alebo nie
   *
   * @return boolean
   */
  get isManipulationAllowed(): boolean {
    let isTrue: boolean = false
    if (_.first(this.reservationItem) && _.first(this.reservationItem)!.status === 'delivered' && !this.lastReservationDetailData) {
      isTrue = false
    } /*else if (!isValidDateForOrdering(this.date as unknown as Date)) {
      return false
    }*/
    else if(this.isEnabledRating) {
      isTrue = true
    } else {
      isTrue = true
    }

    return isTrue
  }

  get isPriseForTag (): any[] {
    let data: any[] = []
    data = this.currentUser.boarderList[0].customer.configuration.allow_show_price_for_tag
    return data
  }

  get isEnabledRating(): boolean {
    this.ratingDeliveryTimeData = this.currentUser.boarderList[0].customer.configuration.last_order_rating_delivery_time_delta ? this.currentUser.boarderList[0].customer.configuration.last_order_rating_delivery_time_delta : undefined
    return this.currentUser.boarderList[0].customer.configuration.allow_rating_last_order

  }

  get selectedMenuItem(): any {
    return this.$store.getters[GET_SELECTED_MENU_ITEM]
  }

  get currentUser(): any {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get isMultiplePortion (): boolean {
    return this.currentUser.boarderList[0].customer.configuration.allow_multiple_portions || false
  }

  get isBoarderNote (): boolean {
    return this.currentUser.boarderList[0].customer.configuration.allow_reservation_note || false
  }

  get statusMessageClass(): string | undefined {
    if (_.first(this.reservationItem)) {
      switch (_.first(this.reservationItem)!.status) {
        case ReservationStatus.active:
          return 'reservation-active'
        case ReservationStatus.canceled:
          return 'reservation-canceled'
        case ReservationStatus.delivered:
          return 'reservation-delivered'
        case ReservationStatus.notDelivered:
          return 'reservation-not-delivered'
      }
    }

    return undefined
  }

  get reservationStatusMessage(): TranslateResult | undefined {
    if(this.timeBlockCollection && this.timeBlockCollection.length == 1){
      const deadLine = moment(this.timeBlockCollection[0].reservationDeadline.toString(),'HH:mm:ss').format('HH:mm')
      return this.$t('orderPage.noticeOrderFoodBeforeDefinedTime',{deadLine: deadLine})
    }

    if (this.isManipulationAllowed) {
      this.$t('orderPage.orderSummaryLabel', { day: this.dateLabel })

      if (_.first(this.reservationItem)) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.active:
            return this.$t('orderPage.reservationForDateIsActiveMessage', { date: this.dateLabel })
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationForDateIsCanceledMessage', { date: this.dateLabel })
          case ReservationStatus.delivered:
            return this.$t('orderPage.reservationWasAlreadyDeliveredMessage')
        }
      } else {
        return this.$t('orderPage.noReservationSoFarMessage', { date: this.dateLabel })
      }
    } else {
      if (_.first(this.reservationItem)) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationWasCanceledMessage')
          case ReservationStatus.delivered:
            return this.$t('orderPage.reservationWasAlreadyDeliveredMessage')
          case ReservationStatus.notDelivered:
            return this.$t('orderPage.reservationWasNotDeliveredMessage')
          default:
            return this.$t('orderPage.reservationWasProcessedMessage')
        }
      }
    }
    return undefined
  }

  get isOfferEmpty(): boolean {
    // Ziadna z podkupin nemoze mat definovanu ponuku
    if(this.tab !== null) {
      return this.effectiveMenuGroups[this.tab].subGroupList.every((i: MenuGroupItem) => {
        return i.optionList.every((option: DailyMenuOption) => option.offer === undefined)
      })
    } else {
      return false
    }
  }

  get isSubmitButtonDisabled (): boolean {
    return this.selectedTimeBlock == null || this.isOfferEmpty || this.timeBlockCollection![this.selectedTimeBlock].id === _.first(this.reservationItem)?.timeBlock.id
  }

  get topMenuGroup(): boolean {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_CHANGE_SET]
  }

  get topMenuGroupSaved(): any {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_SAVED]
  }

  get showMenuGroupTabs(): boolean {
    let showMenuGroups = true

    if (this.areTimeBlockLinkedToGroups()) {
      showMenuGroups = this.effectiveMenuGroups.length > 1
    }

    return showMenuGroups;
  }

  getTabNumber() {
    if(this.selectedMenu && this.selectedMenu === "Denné menu" ) {
      this.tab = 0
    }else if(this.selectedMenu && this.selectedMenu === "Bagety" ) {
      this.tab = 1
    }else if( this.selectedMenu && this.selectedMenu === "Minútky" ) {
      this.tab = 2
    }else if( this.selectedMenu && this.selectedMenu === "Šaláty" ) {
      this.tab = 3
    } else if( this.selectedMenu && this.selectedMenu === "XXL" ) {
      this.tab = 4
    }else {
      this.tab = 0
    }
    this.$store.dispatch(SET_SELECTED_MENU_ITEM, undefined)
  }

  get isAcceptanceProcess(): boolean {
    let condition: boolean = false
    const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_acceptance_process')
    if(foundItem){
      condition = foundItem.value === 'true'
    } else {
      condition = false
    }

    return condition
  }

  get isAlertShow ():boolean {
    if(!this.isMultipleGroupMenu){
      return !!(this.isAmountChanged || this.isDataChanged || this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && _.first(this.reservationItem) && _.first(this.reservationItem)!.timeBlock && this.timeBlockCollection[this.selectedTimeBlock].id !== _.first(this.reservationItem)!.timeBlock.id)
    } else {
      return this.isAmountChanged  || this.isDataChanged || this.isTimeBlockChangeMultiple
    }
  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }


  isTimeBlockDisabled (item: any): boolean {
    const targetDay = moment(this.date).startOf('day')
    const isToday = targetDay.isSame(moment().startOf('day'))

    // a day already in the past is always closed
    if (targetDay.isBefore(moment().startOf('day'))) {
      return true
    }

    // deadline gate — mirrors the backend for today and future days alike:
    // the effective deadline is the target day (or the previous day) at the
    // block's configured time.
    if (item.reservationDeadline) {
      const [hours, minutes, seconds] = item.reservationDeadline.split(':')
      const deadline = targetDay.clone()
        .hours(Number(hours)).minutes(Number(minutes)).seconds(Number(seconds) || 0)
      if (item.deadlineForPreviousDay) {
        deadline.subtract(1, 'day')
      }
      if (moment().isAfter(deadline)) {
        return true
      }
    }

    // an existing non-active reservation locks the block on future days
    if (!isToday && _.first(this.reservationItem) && _.first(this.reservationItem)?.status !== ReservationStatus.active) {
      return true
    }

    return false
  }

  @Watch('selectedTimeBlock')
  watchSelectedTimeBlock(newIndex: any) {
    if (newIndex >= 0 && this.areTimeBlockLinkedToGroups()) {
      let selectedTimeBlock: BusinessTimeBlockCollection = this.timeBlockCollection![newIndex]

      let menuGroupIds: Number[] = []

      this.configuration.forEach((c: Configuration) => {
        let ids = (c.settings as any)?.time_block_menu_group_link[selectedTimeBlock.id] || []

        menuGroupIds = menuGroupIds.concat(ids)
      })

      menuGroupIds = _.uniq(menuGroupIds)

      this.effectiveMenuGroups = this.menuGroupList.filter((m: MenuGroupItem) => menuGroupIds.includes((m.id as any)))
    }
  }

  @Watch('menuGroupItem')
  watchMenuGroupItem (newVal: MenuGroupItem): void {
    if (newVal) {
      this.currentSelection.clear()
      this.setCurrentSelectionByReservation()
      this.updateIsDataChangedFlag()
      this.setTimeBlock()
    }
  }

  @Watch('reservationItem')
  watchReservationItem (newVal: any): void {
    this.updateIsDataChangedFlag()
    this.setTimeBlock()
    this.selectedMenu = this.selectedMenuItem
    this.getTabNumber()
  }

  @Watch('selectedMenuItem')
  watchSelectedMenu (newVal: any): void {
    if(newVal){
      this.selectedMenu = newVal
      this.getTabNumber()
    }
  }

  @Watch('restore')
  watcRestore (newVal: any): void {
    if(newVal){
      this.restore = newVal
    }
  }

  @Watch('showCancellationConfirmationDialog')
  watcShowCancellationConfirmationDialog (newVal: boolean): void {
    if(newVal){
      this.showCancellationConfirmationDialog = newVal
      if(this.showCancellationConfirmationDialog === true) {
        window.addEventListener('keyup',this.performSave)
      }
    }
  }

  @Watch('menuGroupList')
  watchMenuGroupList (newVal: any): void {
    // FIXME: Aktualne sa len nastavi hodnota, koli hotfixu.
    //        Neberu sa do uvahy linkovane skupiny a timebloky.
    //        Je potrebne aplikovat logiku filtrovania linkovanych skupin inak feature nebude fungovat
    this.effectiveMenuGroups = newVal
  }

  newAmount (option: DailyMenuOption): void {
    let changes: boolean[] = []
    this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
      if(value instanceof Array) {
        value.forEach((item: DailyMenuOption) => {
          if(item && item.offer && item.offer.id === option.offer!.id) {
            item.offer.amount = option.offer!.amount
          }

          if(item.offer) {

            this.reservationItem?.forEach((i: any) => {
              const foundItem = i.reservedOffers.find((a: any) => a.dailyMenuOffer.id === item.offer!.id)
              if (foundItem && foundItem.amount !== item.offer!.amount) {
                changes.push(true)
              } else {
                changes.push(false)
              }
            })

          } else {
            changes.push(false)
          }
        })
      } else {
        if(value && value.offer && value.offer.id === option.offer!.id) {
          value.offer.amount = option.offer!.amount
        }

        if(value.offer) {

          this.reservationItem?.forEach((i: any) => {
            const foundItem = i.reservedOffers.find((item: any) => item.dailyMenuOffer.id === value.offer!.id)
            if (foundItem && foundItem.amount !== value.offer!.amount) {
              changes.push(true)
            } else {
              changes.push(false)
            }
          })

        } else {
          changes.push(false)
        }

      }
    })

    this.isAmountChanged = changes.includes(true)
  }

  getReservationItem (menuGroupId: string):  MenuReservationItem | null {
    const foundReservationItem: MenuReservationItem | undefined = this.reservationItem?.find((item: MenuReservationItem) => item.topMenuGroup.id === menuGroupId)
    return foundReservationItem ? foundReservationItem : null
  }

  setTimeBlock (): void {
    if(this.reservationItem) {
      const foundItem: any = this.timeBlockCollection?.find((item: any) => item.id === _.first(this.reservationItem)?.timeBlock.id)
      if(foundItem) {
        const index: number = this.timeBlockCollection!.indexOf(foundItem)
        this.selectedTimeBlock = index
      }
    } else {
      this.selectedTimeBlock = null
      this.timeBlockCollection?.forEach((item: BusinessTimeBlockCollection) => {
        if(!this.isTimeBlockDisabled(item) && this.selectedTimeBlock === null) {
          const index: number = this.timeBlockCollection!.indexOf(item)
          this.selectedTimeBlock = index
        }
      })
    }
  }

  // <editor-fold desc="Event handlers">
  onSelectedOptionChange (groupItem: MenuGroupItem, selectedOption: DailyMenuOption | DailyMenuOption[] | undefined): void {
    if (selectedOption) {
      if(selectedOption instanceof Array) {
        let value: DailyMenuOption[] = []
        selectedOption.forEach((item: DailyMenuOption) => {
          value.push(item)

        })
        this.currentSelection.set(groupItem, value)
      } else {
        this.currentSelection.set(groupItem, selectedOption)
      }
    } else if (this.currentSelection.has(groupItem)) {
      this.currentSelection.delete(groupItem)
    }
    this.updateIsDataChangedFlag()
    this.$emit('selectionChange', this.currentSelection)
  }

  onCloseControlDialogClick():void {
    this.showControlDialog = false
  }


  onPlaceNewReservationClick (): void {

    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && !this.isMultipleGroupMenu) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItem = this.effectiveMenuGroups[this.tab]
      this.currentSelection.forEach((value: any, key: any) => {
        const foundItem: MenuGroupItem | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItem) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false) && validateOrderCorrectness(this.currentSelection, this.effectiveMenuGroups[this.tab], this.configuration)) {
        this.isUpdate = false
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        this.currentSelection.forEach((value: any, key: any) => {
          const foundItem: MenuGroupItem | undefined = this.effectiveMenuGroups[this.tab!].subGroupList.find((item: MenuGroupItem) => item.id === key.id)
          if(!foundItem) {
            selectionPayload.delete((key))
          }
        })
        //this.onConfirmDialogClick(selectionPayload)
      } else {
        if(validateOrderCorrectness(this.currentSelection, this.effectiveMenuGroups[this.tab], this.configuration )){
          this.showControlDialog = true
        }else{
          this.snackBarColor = 'error'
          this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
          this.showSnackBar = true
        }
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    } else {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
    }
  }

  async refreshData ():Promise<void>{
    const payload = _.first(this.reservationItem)!.id
    this.loading = true
    try {
      const data: any = await this.fetchReservationBySelectedId(payload)
      this.$emit('refreshData',data)
    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.errorRefreshData')
      this.showSnackBar = true
    }finally {
      this.loading = false
    }
  }

  async placeNewReservationClick(selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>,desciption: string | null): Promise<void> {
    this.timeBlockId = this.selectedTimeBlock ? `/api/time-block/${this.timeBlockCollection![this.selectedTimeBlock].id}` : `/api/time-block/${this.timeBlockCollection![0].id}`
    const business: any = `/api/business/${this.business}`
    if(!this.isTimeBlockDisabled(this.selectedTimeBlock ? this.selectedTimeBlock : this.timeBlockCollection![0].id)) {
      if (this.currentSelection && this.tab !== null ) {
        this.saveInProgress = true
        this.showWaitList = true

        if(this.isMultipleGroupMenu) {
          let payloadData: CreateNewReservationPayload[] = []
          selectionPayload.forEach((value: DailyMenuOption | DailyMenuOption[],key:MenuGroupItem) => {
            const foundTopGroup: MenuGroupItem | undefined = this.effectiveMenuGroups.find((item: MenuGroupItem) => item.subGroupList.find((i: MenuGroupItem) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
              })
            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
            }
            const foundPayloadData: CreateNewReservationPayload | undefined = payloadData.find((a: CreateNewReservationPayload) => a.topMenuGroup == parseInt(foundTopGroup!.id))

            if(!foundPayloadData) {
              payloadData.push(
                  {
                    boarder: this.currentUser.boarderList[0].id,
                    topMenuGroup: parseFloat(foundTopGroup!.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    date: moment(this.date).format('YYYY-MM-DD'),
                    boarderNote: desciption && desciption.trim().length > 0 ? desciption.trim() : null,
                  }
              )
            } else {
              foundPayloadData.reservedOffers = (foundPayloadData.reservedOffers || []).concat(reservationsOffers)
            }
          })

          let promises: any[] = []

          payloadData.forEach((payload: CreateNewReservationPayload) => {
            promises.push(this.createReservation(payload))
          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let topMenuGroupId: number = parseFloat(this.effectiveMenuGroups[this.tab].id)
          if (topMenuGroupId && validateOrderCorrectness(selectionPayload, this.effectiveMenuGroups[this.tab], this.configuration)) {
            let reservationsOffers: ReservationsOffersPayload[] = []

            selectionPayload.forEach((value) => {
              if(value instanceof Array) {
                value.forEach((item: DailyMenuOption) => {
                  reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
                })

              } else {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
              }
            })
            const payload: CreateNewReservationPayload = {
              boarder: this.currentUser.boarderList[0].id,
              topMenuGroup: parseFloat(this.effectiveMenuGroups[this.tab].id),
              reservedOffers: reservationsOffers,
              timeBlock: this.timeBlockId,
              business: business,
              date: moment(this.date).format('YYYY-MM-DD'),
              boarderNote: desciption && desciption.trim().length > 0 ? desciption.trim() : null,
            }

            this.createReservation(payload)

          } else {
            this.snackBarColor = 'error'
            this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
            this.showSnackBar = true
            this.$emit('updateData')
          }
        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
    }
  }

  async createReservation (payload: CreateNewReservationPayload): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(PLACE_NEW_RESERVATION, payload)

      this.$emit('newReservationCreated', reservationItem)
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  onChangeReservationClick (): void {
    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && !this.isMultipleGroupMenu) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItem = this.effectiveMenuGroups[this.tab]
      this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
        const foundItem: MenuGroupItem | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItem) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false) && validateOrderCorrectness(this.currentSelection, this.effectiveMenuGroups[this.tab], this.configuration )) {
        this.isUpdate = true
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
          const foundItem: MenuGroupItem | undefined = this.effectiveMenuGroups[this.tab!].subGroupList.find((item: MenuGroupItem) => item.id === key.id)
          if(!foundItem) {
            selectionPayload.delete((key))
          }
        })
        //this.onConfirmDialogClick(selectionPayload)

      } else {
        if(validateOrderCorrectness(this.currentSelection, this.effectiveMenuGroups[this.tab], this.configuration )){
          this.isUpdate = true
          this.showControlDialog = true//this.changeReservationClick(this.currentSelection)
        }else{
          this.snackBarColor = 'error'
          this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
          this.showSnackBar = true
        }
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    }  else{
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
    }
  }

  restoreOffer() {
    this.showControlDialog = false
    this.onRestoreReservationClick()
  }


  onConfirmDialogClick (selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>, desciption: string | null) {
    if(_.first(this.reservationItem)?.topMenuGroup.id){
      if(this.isUpdate ) {
        this.showControlDialog = false
        this.changeReservationClick(selectionPayload,desciption)
      } else if (this.restore) {
        this.onRestoreReservationClick()
      } else{
        this.showControlDialog = false
        this.placeNewReservationClick(selectionPayload,desciption)
      }
    } else {
      this.showControlDialog = false
      this.placeNewReservationClick(selectionPayload,desciption)
    }
  }

  performSave(event: KeyboardEvent) {
    if(!this.isInvalidCredentials) {
      if (event.key !== "Enter") {
        this.partialUserId += event.key
      } else {
        if (this.partialUserId.includes('lunchmenu.today')) {
          this.userId = this.partialUserId.slice(-36)
        } else {
          this.userId = this.partialUserId
        }
        this.partialUserId = ''
        this.isInvalidCredentials = false
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.cancellationInProgress = true
        this.onLogUser(this.userId)
      }
    }
  }

  async onLogUser(item: string): Promise<void> {
    const payload: UserCredentialsPayload = {
      username: item,
      password: 'qr'
    }
    this.setIsOrderConfirmation(true)
    const response: boolean = await this.orderConfirmation(payload)
    this.cancellationInProgress = false
    this.setIsOrderConfirmation(false)
    if(response){
      this.onConfirmCancellationButtonClick()
    } else {
      window.addEventListener('keyup',this.performSave)
      this.isInvalidCredentials = true
    }
  }

  async changeReservationClick (selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>,description: string | null): Promise<void> {
    this.timeBlockId = `/api/time-block/${this.timeBlockCollection![this.selectedTimeBlock].id}`
    const business: any = `/api/business/${this.business}`
    if(!this.isTimeBlockDisabled(this.selectedTimeBlock)) {
      if (this.tab !== null && validateOrderCorrectness(selectionPayload, this.effectiveMenuGroups[this.tab], this.configuration )) {
        this.saveInProgress = true
        this.showWaitList = true

        if(this.isMultipleGroupMenu) {
          let payloadData: ChangeExistingReservationPayload[] = []
          selectionPayload.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
            const foundTopGroup: any = this.effectiveMenuGroups.find((item: MenuGroupItem) => item.subGroupList.find((i: MenuGroupItem) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
              })
            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
            }
            const foundPayloadData: ChangeExistingReservationPayload | undefined = payloadData.find((a: ChangeExistingReservationPayload) => a.topMenuGroup === foundTopGroup.id)
            if(!foundPayloadData) {
              payloadData.push(
                  {
                    topMenuGroup: parseFloat(foundTopGroup.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null,
                  }
              )
            } else {
              foundPayloadData.reservedOffers = (foundPayloadData.reservedOffers || []).concat(reservationsOffers)
            }
          })

          this.reservationItem!.forEach((item: MenuReservationItem) => {
            const foundReservationPayload: ChangeExistingReservationPayload | undefined = payloadData.find((i: ChangeExistingReservationPayload) => item.topMenuGroup.id === i.topMenuGroup)
            if(!foundReservationPayload) {
              payloadData.push(
                  {
                    topMenuGroup: item.topMenuGroup.id,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null,
                  }
              )
            }
          })

          let promises: any[] = []

          payloadData.forEach((b: ChangeExistingReservationPayload) => {
            const foundReservation: MenuReservationItem | undefined = this.reservationItem!.find((c: MenuReservationItem) => c.topMenuGroup.id === b.topMenuGroup)
            if(foundReservation) {
              const payload: ChangeExistingReservationWithIdPayload = {
                reservationId: foundReservation.id,
                payload: b
              }
              promises.push(this.changeReservation(payload))
            } else {
              const payload: CreateNewReservationPayload = {
                boarder: this.currentUser.boarderList[0].id,
                topMenuGroup: b.topMenuGroup,
                reservedOffers: b.reservedOffers || [],
                timeBlock: this.timeBlockId!,
                business: business,
                date: moment(this.date).format('YYYY-MM-DD'),
                boarderNote: description && description.trim().length > 0 ? description.trim() : null,
              }
              promises.push(this.createReservation(payload))
            }

          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let reservationsOffers: ReservationsOffersPayload[] = []
          selectionPayload.forEach((value) => {
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
                //offerIds.push(parseInt(item.offer!.id))
              })

            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
              //offerIds.push(parseInt(value.offer!.id))
            }
          })

          const payloadData: ChangeExistingReservationPayload = {
            topMenuGroup: parseFloat(this.effectiveMenuGroups[this.tab].id),
            reservedOffers: reservationsOffers,
            timeBlock: this.timeBlockId,
            business: business,
            boarderNote: description && description.trim().length > 0 ? description.trim() : null,
          }

          const payload: ChangeExistingReservationWithIdPayload = {
            reservationId: _.first(this.reservationItem)!.reservationId,
            payload: payloadData
          }

         this.changeReservation(payload)

        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
    } else {
      this.snackBarColor = 'error'
      this.snackBarText =  this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
      this.$emit('updateData')
    }
  }

  async changeReservation (payload: ChangeExistingReservationWithIdPayload): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CHANGE_EXISTING_RESERVATION, payload)
      this.$emit('reservationChanged', reservationItem, 'changed')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  async restoreReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, payload)
      window.removeEventListener('keyup',this.performSave)
      if(this.timeOut) {
        clearTimeout(this.timeOut)
      }

      this.$emit('reservationChanged', reservationItem, 'canceled')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.cancellationInProgress = false
    }
  }

  async restoredReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION,payload)
      this.restartedReservation = true
      this.$emit('reservationChanged', reservationItem, 'restored')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.saveInProgress = false
      this.restartedReservation = false
    }
  }


  onCancelReservationClick (): void {
    this.showCancellationConfirmationDialog = true
  }

  async fetchData (): Promise<void> {
    try {
      this.timeBlockCollection = await this.piniaStore.fetchTimeBlocks({
        currentUser: this.currentUser
      })
    }catch (e) {
    }
  }

  onReservationRstoreClick () {
    this.restore = true
    this.showControlDialog = true
  }

  async onRestoreReservationClick (): Promise<void> {
    if (this.reservationItem && this.isMultipleGroupMenu) {
      this.saveInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoredReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        this.restartedReservation = true
        this.$emit('reservationChanged', reservationItem, 'restored')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.saveInProgress = false
        this.restartedReservation = false
      }
    }
  }


  onCancelCancellationButtonClick (): void {
    this.showCancellationConfirmationDialog = false
    window.removeEventListener('keyup',this.performSave)
    if(this.timeOut) {
      clearTimeout(this.timeOut)
    }
  }

  async onConfirmCancellationButtonClick (): Promise<void> {
    this.showCancellationConfirmationDialog = false

    if (this.reservationItem &&  this.isMultipleGroupMenu) {
      this.cancellationInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoreReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        window.removeEventListener('keyup',this.performSave)
        if(this.timeOut) {
          clearTimeout(this.timeOut)
        }

        this.$emit('reservationChanged', reservationItem, 'canceled')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.cancellationInProgress = false
      }
    }
  }
  // </editor-fold>

  /**
    * Zmení flag isDataChanged podľa nastavenia rezervácie
    *
    * Vue nepodporuje reaktivitu pre property typu Map a Set. Preto musí byť zmena flagu riešená explicitne.
  */
  updateIsDataChangedFlag (): void {
    this.isAmountChanged = false
    if (!this.reservationItem) {
      this.isDataChanged = false
    } else {
      this.isDataChanged = isSelectionDifferentThenReservation(this.reservationItem, this.currentSelection, this.isMultipleGroupMenu)
    }
  }

  async fetchLatestOrderDetail(): Promise<void> {
    this.lastReservationDetailData = []
    try {
      const promises: Promise<any>[] = []
      this.lastReservationNumber!.forEach((number: number) => {
        let payload: any = number
        promises.push(this.piniaStore.fetchLastOrder(payload))
      })
      const responses = await Promise.all(promises)
      this.lastReservationDetailData.push(responses)
    } catch (e) {
    }
  }

  async fetchLastData(): Promise<void> {
    this.lastReservationNumber = []
    this.isRefreshData = true
    const dashboard = await this.$store.dispatch(FETCH_DASHBOARD)
    dashboard.offerReservationsToRate.forEach((item:any) => {
      this.selectedOfferRating = item.offerReservationRating
      this.lastReservationNumber!.push(item.offerReservation.id)
    })
    this.isRefreshData = false
    if(this.lastReservationNumber !== null) {
      this.fetchLatestOrderDetail()
    }



  }

  showSaveErrorMessage (e: AxiosError): void {
    showErrorResponseDialog(this.$t('orderPage.orderNotSaved'), e, this.$t('errorResponseDialog.contactAdministratorMessage').toString())
  }

  destroyed(){
    window.removeEventListener('keyup',this.performSave)
    if(this.timeOut) {
      clearTimeout(this.timeOut)
    }
  }

  setCurrentSelectionByReservation (): void {

    if(this.reservationItem && this.isMultipleGroupMenu){
      let reservedIdList: number[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        item.reservedOfferCollection.forEach((i: any) => {
          reservedIdList.push(i.menuGroupSlot.id)
        })
      })
      this.effectiveMenuGroups.forEach((item: MenuGroupItem) => {
        item.subGroupList.forEach((i: MenuGroupItem) => {
          i.optionList.forEach((a: DailyMenuOption) => {
            if(reservedIdList.includes(parseInt(a.id))) {
              if(this.currentSelection.has(i)) {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.get(i)!.push(a)
              } else {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.set(i, [a])
              }
            }
          })
        })
      })

    }
  }

  areTimeBlockLinkedToGroups(): boolean {
    let haveLinks = this.configuration.some((c: Configuration) => {
      let links = (c.settings as any).time_block_menu_group_link

      return links && Object.keys(links).length > 0
    })

    return haveLinks;
  }

  created() {
    const vh = window.innerHeight
    this.cardHeight = `max-height: calc(${vh}px - 240px);height: calc(${vh}px - 240px)`
    this.isMultipleGroupMenu = this.customerConfiguration
    this.setCurrentSelectionByReservation()

  }

  async mounted() {
    this.effectiveMenuGroups = this.menuGroupList

    this.business = this.currentUser.tenant.businessCollection[0].id

    await this.fetchData()
    this.setTimeBlock()

    if(this.reservationItem && _.first(this.reservationItem)?.topMenuGroup) {
      this.getTabNumber()
    } else if(this.selectedMenu) {
      this.getTabNumber()
    } else{
      this.tab = 0
    }
    this.fetchLastData()
    this.fetchLatestOrderDetail()
  }
}
</script>

<style lang="stylus" scoped>

.row-style {
  padding-top 300px
}

.card-style {
  >>> .v-slide-group__content.v-tabs-bar__content{
    padding-right 0px
  }
}

.title-style
  color red

.style {
  >>> .v-alert__icon{
   padding-top 30px
  }
}

.reservation-active, .reservation-delivered {
  background-color: #c8e6c9
}

.reservation-canceled, .reservation-not-delivered {
  background-color: #fadacd
    }

.reservation-status >>> em {
  font-weight: 500;
  font-style: normal;
  text-decoration: underline
}

.main-title {
  word-break: unset
}

.selected_date {
  color: #008b8b
}

.guiding-image{
  height 250px
  top 100px
}




</style>
